import React from "react";
import "./Select.css";

interface SelectProps {
  label?: string;
  name: string;
  options: { label: string; value: string }[];
  required?: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabledValue?: string;
  style?: React.CSSProperties;
}

const Select: React.FC<SelectProps> = ({
  label,
  options,
  required = false,
  value,
  onChange,
  disabledValue = "Select",
  name,
  style,
}) => {
  return (
    <div className="form-group">
      <label>
        {label} {required && <span className="required">*</span>}
      </label>
      <select
        className="custom-select"
        name={name}
        required={required}
        value={value}
        onChange={onChange}
        style={style}
      >
        {value === "" && (
          <option value="" disabled>
            {disabledValue}
          </option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};
export default Select;
